import { render, staticRenderFns } from "./InputLloodTextarea.vue?vue&type=template&id=85fa4482"
import script from "./InputLloodTextarea.vue?vue&type=script&lang=js"
export * from "./InputLloodTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports